import { render } from "./VentsTable.vue?vue&type=template&id=20d8d583&scoped=true"
import script from "./VentsTable.vue?vue&type=script&lang=js"
export * from "./VentsTable.vue?vue&type=script&lang=js"

import "./VentsTable.vue?vue&type=style&index=0&id=20d8d583&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d8d583"]])

export default __exports__